<template>
	<!--风险告知函提示框-->
	<div class="model-container animated-5 fadeIn" v-if="showModel">
		<div class="model-box posi-relative">
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<!--标题-->
				<span class="mdl-title"><span style="color:#333;!important">养老目标基金风险揭示书</span></span>
				<!--关闭按钮-->
				<span @click="$emit('modelCancle')">X</span>
			</p>
			<!-- 主要内容 -->
			<div class="model-content flex-dire-btw jss">
                <div>
                    <div>
                        <p v-for="(item,index) in imgList" :key="index">
                            <img :src="item.filePath" style="max-width:100%;">
                        </p>
                    </div>
				</div>
				<div class="txt-center mdl-btn-box">
                    <!-- @click="callnes()" -->
					<btn-middle v-if="isDisable" class="btn-disabled" >我已阅读并同意</btn-middle>
                    <btn-middle v-else @click="$emit('agreeFn')">我已阅读并同意</btn-middle>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性
        props:['showModel','isFixed','fundCode','isShowFXJS'],
		data(){
			return{
                imgList:[],
                isDisable:false
			}
        },		 
        watch:{
            showModel(){
                if(this.showModel){
                    let fundCode = this.fundCode || this.$parent.fundCode;
                    if(fundCode){
                        this.imgList = [];
                        this.$axios_post('trade/pre/fund/disclosure',{fundCode:fundCode,fileType:'01'}).then(res=>{
                            console.log('res',res);
                            if(res.code = "00000000"){
                                if(res.dataList && res.dataList.length>0){
                                    this.imgList = res.dataList[0].fileList;
                                }
                                let that = this, nScrollTop= 0,imgHeight = 0;
                                // that.$nextTick(() => {
                                //     $(".jss>div").scroll(function(){
                                //         nScrollTop = $(this)[0].scrollTop;
                                //         imgHeight = $(this).find('div').height();
                                //         if(nScrollTop + 400 >= imgHeight){
                                //             that.isDisable = false;
                                //         }
                                //     });
                                // })
                            }
                        })
                    }else{
                        //this.isDisable = true;
                    }
                }else{
                    //this.isDisable = true;
                }
            }
        },
		methods:{
              callnes(){
                  this.$store.commit('showErrorInfo', {type: 'fail', msg: '请阅读至底部!'});
              }
		}
	}
</script>

<style scoped lang='less'>
	.model-container{
        display: block;
      
        .model-box{ 
            width:30rem;
            top:15%; 
            .model-content{ 
                padding-top:.5rem;
                padding-right:.35rem;
                >div:first-child{
                    height:15rem;
                    overflow: auto;
                }
                p{ 
                    padding-right:.3rem;
                    line-height: 1.2rem;
                }
                button{ 
                    margin-top:1rem; 
                    width: 11rem;
                }
            }
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/modelCommFxjss.vue